<div fxLayout="column" class="full-width" *ngIf="dataSource.data?.length">
  <div fxLayout="row" fxLayoutAlign="end center" fxFlexFill class="secondary-text layout padding-8">
    <button mat-icon-button matTooltip="Download" (click)="export()" [disabled]="isExporting">
      <mat-icon *ngIf="!isExporting">get_app</mat-icon>
      <mat-spinner *ngIf="isExporting" diameter="20"></mat-spinner>
    </button>
  </div>

  <ifc-app-scroll-container class="scroll-container">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let payment" class="table-cell">{{ payment.date | date: 'shortDate' }}</td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef class="right-align">Amount</th>
        <td mat-cell *matCellDef="let payment" class="table-cell right-align">
          {{ payment.principalAmount + payment.interestAmount | currency: '$' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="principalAmount">
        <th mat-header-cell *matHeaderCellDef class="right-align">Principal</th>
        <td mat-cell *matCellDef="let payment" class="table-cell right-align">
          {{ payment.principalAmount | currency: '$' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="interestAmount">
        <th mat-header-cell *matHeaderCellDef class="right-align">Interest</th>
        <td mat-cell *matCellDef="let payment" class="table-cell right-align">
          {{ payment.interestAmount | currency: '$' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="balance">
        <th mat-header-cell *matHeaderCellDef class="right-align">
          {{ isPublicView ? 'Closing balance' : 'Balance' }}
        </th>
        <td mat-cell *matCellDef="let payment" class="table-cell right-align">
          {{ payment?.principalBalance | currency: '$' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="totalInterestCost">
        <th mat-header-cell *matHeaderCellDef class="right-align">Total interest cost</th>
        <td mat-cell *matCellDef="let payment" class="table-cell right-align">
          {{ payment.interestPaid | currency: '$' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="capitalRepayment">
        <th mat-header-cell *matHeaderCellDef class="right-align" [ngClass]="{ hide: !isPublicView }">
          {{ isPublicView ? 'Total capital repayment' : 'Capital repayment' }}
        </th>
        <td mat-cell *matCellDef="let payment" class="table-cell right-align" [ngClass]="{ hide: !isPublicView }">
          {{ payment.capitalRepayment | currency: '$' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="totalPayback">
        <th mat-header-cell *matHeaderCellDef class="right-align hide">Total payback</th>
        <td mat-cell *matCellDef="let payment" class="table-cell right-align hide">
          {{ payment.totalPayback | currency: '$' }}
        </td>
      </ng-container>

      <ng-container *ngIf="offerDetail?.productCode === productCode.Term && isPublicView" matColumnDef="discount">
        <th mat-header-cell *matHeaderCellDef class="right-align">Discount available</th>
        <td mat-cell *matCellDef="let payment" class="table-cell right-align">
          {{ payment.discountAvailable | currency: '$' }}
        </td>
      </ng-container>

      <ng-container *ngIf="offerDetail?.productCode === productCode.Term" matColumnDef="payoff">
        <th mat-header-cell *matHeaderCellDef class="right-align">
          {{ isPublicView ? 'Payoff amount' : 'Discounted payoff' }}
        </th>
        <td mat-cell *matCellDef="let payment" class="table-cell right-align">
          {{ payment.payoffAmount | currency: '$' }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="table-header"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="table-row"></tr>
    </table>
  </ifc-app-scroll-container>

  <mat-paginator showFirstLastButtons [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
</div>
